export enum Language {
    EN = "en",
    FR = "fr",
}
